
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/chrisrecord",
      function () {
        return require("private-next-pages/chrisrecord.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/chrisrecord"])
      });
    }
  